import { Flex, IconOrganizationFilled24 } from '@gmg/gmg-react-components';
import { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../AppContext';
import { useOrganizations } from '../../graphql/useOrganizations';
import WrappedSpinner from '../../shared/WrappedSpinner';
import SearchBox from '../shared/SearchBox';
import AddOrganizationBtn from './AddOrganizationBtn';
import OrganizationsList from './OrganizationsList';
import { isGmgPartnerRole } from 'src/role';
import BreadCrumbItem from '../shared/BreadCrumbItem';


const SysadministrationContainer: FC<{}> = () => {
    const { t } = useTranslation();
    const context = useContext(AppContext);
    const { data, isLoading, isFetching, isSuccess, error } = useOrganizations();
    const shouldShowSpinner = isLoading || isFetching;
    const [filterInput, setFilterInput] = useState('');

    const isPartnerPortalNavigationVisible = context.featureFlags.showPartnerPortal && isGmgPartnerRole(context.user!.role);
    const navBarHeight = isPartnerPortalNavigationVisible ? 'var(--navBarHeightWithDealerPortal)' : 'var(--navBarHeightWithoutDealerPortal)';

    useEffect(() => {
        if (!error) {
            return;
        }
        context.onError(error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    return (
        <Flex flexDirection="column" gap="2px" bg="background">
            <Flex width="100%" height="64px" gap="2px" bg="background">
                <Flex width="100%" height="100%" justifyContent="space-between" alignItems="center" bg="backgroundPaper" pr="24px" pl="24px">
                    <BreadCrumbItem
                        label={t('OrganizationList.textWithIcon_title', 'Organizations')}
                        icon={<IconOrganizationFilled24 width={16} height={16}/>}
                        isHighlighted
                    />
                    <Flex gap='16px'>
                        {isSuccess &&
                            <SearchBox onChange={(e) => setFilterInput(e.target.value)} value={filterInput} />
                        }
                        <AddOrganizationBtn
                            existingOrgNames={data
                                ? Array.from(data, org => org?.name.toLowerCase())
                                : undefined
                            }
                        />
                    </Flex>
                </Flex>
            </Flex >

            <Flex flexGrow={1} flexDirection="column" height="var(--app-content-height)" minHeight={navBarHeight} overflow='hidden' justifyContent="center" bg="backgroundPaper">
                {isSuccess && <OrganizationsList orgListData={data} filterInput={filterInput} />}
                {shouldShowSpinner && <WrappedSpinner label={t('Common.Spinner', 'Loading...')} labelPosition="bottom" />}
            </Flex>

        </Flex>
    );
};

export default SysadministrationContainer;

